import { makeObservable, observable } from 'mobx'
import { getTerritory } from '../services/ApiService'
import PagedCollectionStore from '../utils/stores/PagedCollectionStore'

class TerritoryStore extends PagedCollectionStore {
  constructor() {
    super({ action: getTerritory })
    this.territories = {}
    this.urls = {
      днр: `${window.SAT.config.apiUrl}/static/handbooks/dnr.json`,
      лнр: `${window.SAT.config.apiUrl}/static/handbooks/lnr.json`,
      'запорожская область (зо)': `${window.SAT.config.apiUrl}/static/handbooks/zo.json`,
      'херсонская область (хо)': `${window.SAT.config.apiUrl}/static/handbooks/ho.json`,
    }
    this.urlsDev = {
      днр: `${window.SAT.config.apiUrl}/static/handbooks/dnr.json`,
      лнр: `${window.SAT.config.apiUrl}/static/handbooks/lnr.json`,
      'запорожская область (зо)': `${window.SAT.config.apiUrl}/static/handbooks/zo.json`,
      'херсонская область (хо)': `${window.SAT.config.apiUrl}/static/handbooks/ho.json`,
    }
    makeObservable(this, { territories: observable })
  }

  setData(data) {
    data.forEach((el) => {
      fetch(this.urlsDev[el.toLowerCase()])
        .then((res) => res.json())
        .then((res) => (this.territories[el] = res))
    })
    super.setData(data)
  }

  getLocalityInfo = (territoryName, districtName, localityName) =>
    this.territories[territoryName]?.Territory?.Districts?.find(
      (d) => d.Name === districtName,
    )?.Localities?.find((l) => l.Name === localityName)

  isLocalityExists = (territoryName, districtName, localityName) =>
    !!this.getLocalityInfo(territoryName, districtName, localityName)

  getTreeData = () => {
    const territoryTreeItems = Object.keys(this.territories)
      .sort()
      .map((key) => ({
        label: key,
        id: `territory - ${this.territories[key].Territory?.Id}`,
      }))

    const withDistrictsTreeItems = territoryTreeItems.map((item) => {
      const children = this.territories[item.label].Territory.Districts.map(
        (item) => ({ label: item.Name, id: `district - ${item.Id}` }),
      )

      return { ...item, children }
    })

    const withLocalitiesTreeItems = withDistrictsTreeItems.map((obj) => {
      const children = obj.children.map((item) => {
        const localityItem = this.territories[
          obj.label
        ].Territory.Districts.find((el) => el.Name === item.label)

        return {
          ...item,
          children: localityItem.Localities.map((el) => ({
            label: el.Name,
            id: `locality - ${el.Id}`,
            isFullDotation: el.AllowedFinancialSourceIds.includes(1),
          })),
        }
      })

      return { ...obj, children }
    })

    const withAllLabel = [
      { label: 'Все регионы', id: 'main', children: withLocalitiesTreeItems },
    ]

    return withLocalitiesTreeItems ? withAllLabel : []
  }
}

export default TerritoryStore
